import Layout from "@/components/Layout";
import { Link } from "react-router-dom";

const FEATURES = [
  ["Bulk Test ID generation", "Buy test credits in slabs and generate single-use Test IDs in seconds."],
  ["Institution Code + Batch tagging", "Issue access linked to your institution and tag students by batch/program."],
  ["Aggregate analytics", "Domain-wise distribution, completion rates, and batch comparisons."],
  ["Per-student reports", "Download personalized reports for each completed student."],
  ["Slab-based pricing", "Discounted unit prices as your order quantity increases."],
  ["Secure data handling", "OTP-locked Test IDs, single-use enforcement, encrypted storage."],
];

export default function Institutions() {
  return (
    <Layout>
      <section className="container-msis py-16">
        <div className="overline mb-3">For Institutions</div>
        <h1 className="font-display font-bold text-4xl sm:text-5xl tracking-tighter max-w-3xl">Deploy MSIS across your entire batch.</h1>
        <p className="mt-5 text-base text-slate2 max-w-3xl">A turnkey deployment for B-schools, universities, and training academies. No student profile pre-upload needed — students self-register with the Institution Code and Test ID you share.</p>
        <div className="mt-10 grid lg:grid-cols-3 gap-px bg-border">
          {FEATURES.map(([t, d]) => (
            <div key={t} className="bg-white p-6">
              <div className="font-display font-bold text-lg">{t}</div>
              <div className="text-sm text-slate2 mt-2">{d}</div>
            </div>
          ))}
        </div>
        <div className="mt-10 grid lg:grid-cols-2 gap-8 items-center">
          <div>
            <div className="overline mb-3">Institutional Workflow</div>
            <ol className="space-y-3 text-sm text-slate2 list-decimal list-inside">
              <li>Institution purchases desired number of tests in a single transaction.</li>
              <li>Platform issues an Institution Code and Test Credits.</li>
              <li>Institution shares Institution Code + Test IDs with students.</li>
              <li>Each student verifies email via OTP and self-registers.</li>
              <li>Reports are emailed to students and the institution admin.</li>
              <li>Institution dashboard reflects completion, analytics, and downloads.</li>
            </ol>
          </div>
          <div className="card-grid">
            <div className="overline">Ready to deploy?</div>
            <h3 className="font-display font-bold text-2xl mt-2">Get Test Credits</h3>
            <p className="text-sm text-slate2 mt-2">Pricing starts at ₹360 per test (1–100), reducing to ₹310 per test (901+). For international, $9 per test regardless of quantity.</p>
            <div className="mt-4 flex gap-3 flex-wrap">
              <Link to="/pricing" className="btn-primary" data-testid="inst-pricing-btn">View Pricing</Link>
              <Link to="/checkout?plan=institution_inr" className="btn-ghost" data-testid="inst-subscribe-btn">Subscribe Now</Link>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
